import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {DayView} from '../../core/DayView';
import {DataService} from '../../core/data.service';
import {DtoBookingListEntry} from '../../core/DtoBookingListEntry';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'day-detail',
  templateUrl: './day-detail.component.html',
  styleUrls: ['./day-detail.component.css']
})
export class DayDetailComponent implements OnChanges {
  @Input()  dayView: DayView;
  @Output() selectedBookingSid: EventEmitter<any> = new EventEmitter();
  bookings: DtoBookingListEntry[];
  inBookings: DtoBookingListEntry[];
  outBookings: DtoBookingListEntry[];
  existingBookings: DtoBookingListEntry[];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['dayView']) {
            const curr: DayView = changes.dayView.currentValue;
            const dogBookings: number[]  = Object.assign([], curr.dogBookings);
            const allBookings = dogBookings.concat(curr.catBookings);
            this.dataService.callGet('bookingSummaries?date=' + curr.calanderDate + '&id=' + allBookings.join('&id=')).subscribe((it) => {
                this.bookings = it;
                this.inBookings = it.filter(b => b.in === true);
                this.outBookings = it.filter(b => b.out === true);
                this.existingBookings = it.filter(b => b.out === false && b.in === false);
            }, (error) => {
                console.log(error);
            });
        }
    }

  constructor(private dataService: DataService) {
    this.inBookings = [];
    this.outBookings = [];
    this.existingBookings = [];
  }

  selectBooking(sid: number, userSid: number) {
    forkJoin([
            this.dataService.callGet('bookings/' + sid),
            this.dataService.callGet('user/summaryWithPets/' + userSid)]
    ).subscribe(responses => {
        this.selectedBookingSid.next({booking: responses[0], user: responses[1]});
    });
  }
}
